export default __webpack_public_path__ + "static/media/6.82a7ae4d.svg";